import { useSyncExternalStore } from "react";

import { getWorkspaceConfig, subscribeWorkspaceConfigs } from "@/data/workspaceConfig";

/** What a driver's name reads as in demo mode. */
export const DEMO_DRIVER_NAME = "Driver";

/** What an office user's name reads as in demo mode. */
export const DEMO_DISPATCHER_NAME = "Dispatcher";

/** Whether demo mode is on for a workspace: `web.demoMode` is exactly `true` in its compiled config. */
export function isDemoMode(workspaceId: string | undefined): boolean {
  if (!workspaceId) {
    return false;
  }
  return getWorkspaceConfig(workspaceId)?.web?.demoMode === true;
}

/** {@link isDemoMode}, re-read whenever the workspace's config changes. */
export function useDemoMode(workspaceId: string | undefined): boolean {
  const snapshot = () => isDemoMode(workspaceId);
  return useSyncExternalStore(subscribeWorkspaceConfigs, snapshot, snapshot);
}
